import { render, staticRenderFns } from "./PaymentMethodsInfo.vue?vue&type=template&id=f48aecb6&"
import script from "./PaymentMethodsInfo.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodsInfo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports